export default __webpack_public_path__ + "c804877d3640b897afd06a42d7528d97.mp4";